import get from "lodash/get";

const defaultObj = {};

export const getShippingCountry = (state) => get(state, "shipping.country", defaultObj);
